import { jsx as _jsx } from "react/jsx-runtime";
import UIComponent from './uiComponent';
import { resovleContent } from './utils';
function UIBlockComponent(props) {
    return (_jsx("div", { style: { ...props.styling }, children: props.children }));
}
export default class UIBlock extends UIComponent {
    style;
    constructor(s) {
        super(s);
        this.style = this.getProperty('style', '');
        resovleContent(this, s);
    }
    getComponent() {
        const props = {
            styling: this.style,
            children: this.children.map((c) => c.getComponent()),
        };
        return _jsx(UIBlockComponent, { ...props });
    }
}
//# sourceMappingURL=uiBlock.js.map